import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["currentStepNumber", "totalSteps", "customLogo"];
import { Flex } from 'foundations-components/components/Flex';
import { SidePanelLayoutContext } from './SidePanelLayoutContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const Root = props => {
  const {
      currentStepNumber = 1,
      totalSteps = 1,
      customLogo
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(SidePanelLayoutContext.Provider, {
    value: {
      currentStepNumber,
      totalSteps,
      customLogo
    },
    children: /*#__PURE__*/_jsx(Flex, Object.assign({
      blockSize: "100vh",
      overflow: "hidden"
    }, rest))
  });
};